// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Agent application'"></sub-header>
<div ng-if="\$ctrl.editMode && !\$ctrl.application.id">
  <h2 class="section-header">Choose customer type</h2>
  <table class="table table--with-big-buttons">
    <tbody>
    <tr>
      <td class="customer-option">1.</td>
      <td class="customer-option">
        New individual customer
      </td>
      <td class="customer-option">
        <button type="button"
                class="btn btn-primary"
                ng-click="\$ctrl.initCustomer()">
          Choose
        </button>
      </td>
    </tr>
    <tr>
      <td class="customer-option">2.</td>
      <td class="customer-option">
        Existing customer
      </td>
      <td class="customer-option">
        <customer-picker
          on-choose="\$ctrl.chooseExisting(customer)"
          search-criteria="{customerTypes: ['INDIVIDUAL'], customerSubtypes: ['BDA']}">
        </customer-picker>
      </td>
    </tr>
    </tbody>
  </table>
</div>
<form name="\$ctrl.candidacyForm">
  <validator condition="!!\$ctrl.application.customer"></validator>
  <agent-candidacy-header
    ng-if="\$ctrl.application.customer"
    application="\$ctrl.application"
    edit-mode="\$ctrl.editMode"
    edit-status="\$ctrl.editStatus">
  </agent-candidacy-header>
  <div class="alert"
       ng-if="\$ctrl.showWarningAboutIncompleteData()">
    Customer's Individual Data or Addresses contain incomplete data. You can edit it by clicking 'Go to customer
    profile'.
    <button type="button"
            class="btn btn-success"
            ng-if="\$ctrl.application.customer.status !== 'PROSPECT'"
            ng-click="\$ctrl.goToCustomerProfile()">
      Go to customer profile
    </button>
  </div>
  <agent-customer-profile-body
    candidacy="\$ctrl.application"
    edit-mode="\$ctrl.editMode"
    module="'agent'"
    ng-if="\$ctrl.application.customer"
    ng-form="\$ctrl.customerForm"
    individual-data-form="\$ctrl.individualDataForm"
    addresses-form="\$ctrl.addressesForm">
  </agent-customer-profile-body>
  <div class="summary-actions footer">
    <button
      class="btn btn-warning"
      type="button"
      ng-if="\$ctrl.editMode"
      ng-click="\$ctrl.cancelEdit()">
      Cancel
    </button>
    <button
      class="btn btn-warning"
      type="button"
      ng-if="!\$ctrl.editMode"
      ng-click="\$ctrl.redirectBack()">
      Return
    </button>
    <button
      class="btn btn-primary"
      type="button"
      ng-click="\$ctrl.saveApplication()"
      ng-disabled="\$ctrl.candidacyForm.\$invalid"
      ng-if="\$ctrl.editMode || \$ctrl.editStatus">
      Save
    </button>
    <button
      class="btn btn-danger"
      type="button"
      command-access="DisapproveAgentCandidacy"
      ng-if="\$ctrl.application.systemStatus === 'SENT_FOR_APPROVAL' && \$ctrl.processMode"
      ng-click="\$ctrl.disapproveApplication()"
      ng-disabled="\$ctrl.candidacyForm.\$invalid">
      Disapprove
    </button>
    <button
      class="btn btn-success"
      type="button"
      command-access="ApproveAgentCandidacy"
      ng-if="\$ctrl.application.systemStatus === 'SENT_FOR_APPROVAL' && \$ctrl.processMode"
      ng-click="\$ctrl.approveApplication()"
      ng-disabled="\$ctrl.candidacyForm.\$invalid">
      Approve
    </button>
  </div>
</form>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/agent-banking/candidacy/agent-candidacy.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;